import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmBaseComponent } from '../../tm-base.component';

export const tagName = 'tm-section';
@customElement(tagName)
export class TmSection extends TmBaseComponent {
    protected render() {
        return html`<slot></slot>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    background-color: var(--container-primary);
                    box-shadow: var(--content-shadow);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmSection;
    }
}
